<template>
  <div :class="$style.topbar">
    <div class="mr-4" v-if="settings.isMobileView">
      <a href="#" @click="openMobileMenu" :class="$style.handler"><i class="icmn-menu"></i></a>
    </div>
    <div class="mr-auto">
      <cui-breadcrumbs />
    </div>
    <div class="mr-4">
      <cui-language-selector />
    </div>
    <cui-profile-menu />
  </div>
</template>

<script>
import CuiLanguageSelector from '@/components/LayoutComponents/Topbar/LanguageSelector'
import CuiProfileMenu from '@/components/LayoutComponents/Topbar/ProfileMenu'
import CuiBreadcrumbs from '@/components/LayoutComponents/Breadcrumbs'
import { mapState } from 'vuex'

export default {
  components: {
    CuiLanguageSelector,
    CuiProfileMenu,
    CuiBreadcrumbs,
  },
  computed: mapState(['settings']),
  methods: {
    openMobileMenu(e) {
      e.preventDefault()
      const value = !this.settings['isMobileMenuOpen']
      this.$store.commit('CHANGE_SETTING', { setting: 'isMobileMenuOpen', value })
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
